export const APP_VERSION = "1.5";
export const APP_BUILD_DATE = "2026-06-10";